import { Injectable, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { find } from 'lodash-es';

import { LanguageFactory } from './LanguageFactory';
import { WebCommonStorageRepository } from './WebCommonStorageRepository';

const defaultLanguageCode = 'en_US';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  static readonly ajsFactoryName = 'LanguageFactory';

  constructor(
    @Optional() private languageFactory: LanguageFactory | null,
    private translateService: TranslateService,
    private webCommonStorageRepository: WebCommonStorageRepository,
  ) {
  }

  private currentLang = { code: defaultLanguageCode };
  private langOptions = [
    {
      name: 'English',
      id: 'en_US',
    },
    {
      name: 'Spanish',
      id: 'es_MX',
    }
  ];

  // sometimes the language has a '-' in it which doesnt match our language formats with '_'
  private normalizeToUnderscore(language: string) {
    if (language) {
      if (language.length > 1 && language[0] === '"' && language[language.length - 1] === '"') {
        language = language.substring(1, language.length - 1);
      }
      return language.replace('-', '_');
    }
    return language;
  }

  private updateCurrentLangCode(code: string): void {
    const normalizedCode = this.normalizeToUnderscore(code);
    this.currentLang.code = normalizedCode;
    this.languageFactory?.setLang(normalizedCode);
    this.translateService.use(normalizedCode);
  }

  setLang(language: string): void {
    if (!language) {
      return;
    }

    this.updateCurrentLangCode(language);
    this.webCommonStorageRepository.setLang(this.currentLang.code);
  }

  getLang() {
    const currentLangCode = (this.currentLang.code) ? this.normalizeToUnderscore(this.currentLang.code) : defaultLanguageCode;
    this.updateCurrentLangCode(currentLangCode);
    return this.currentLang;
  }

  get getLangOptions() {
    return this.langOptions;
  }

  getActiveLanguage() {
    const targetId = this.getLang().code;
    const activeLanguage = find(this.langOptions, (langOption) => {
      return langOption.id === targetId;
    });
    return activeLanguage;
  }
}
